// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.config-cards-container {
  display: flex;
  flex-direction: column; /* stack cards vertically */
  gap: 16px; /* space between cards */
  max-height: 400px; /* adjust height as needed */
  overflow-y: auto; /* vertical scroll if content exceeds max-height */
  padding-right: 4px; /* optional, prevents scrollbar overlapping content */
  margin-top: 20px;
}

.reset-link {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: none;
  color: #007bff;
  font-size: 13px;
  cursor: pointer;
}

.config-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  word-break: break-word; /* prevent text overflow */
}

.config-card .card-row {
  display: flex;
  flex-direction: row; /* keep them in a row */
  gap: 8px; /* space between label and value */
  margin-bottom: 8px;
  font-size: 14px;
  justify-content: flex-start; /* align everything to the left */
}

.config-card .card-row span {
  word-break: break-word; /* prevent overflowing long text */
}

.config-card .label {
  font-weight: 500;
  color: #555;
  margin-right: 8px;
}

.config-cards-container::-webkit-scrollbar {
  width: 6px;
}

.config-cards-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ModelLibrary/ModelLibrary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,SAAS,EAAE,wBAAwB;EACnC,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB,EAAE,kDAAkD;EACpE,kBAAkB,EAAE,qDAAqD;EACzE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;EACzC,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,uBAAuB;EAC5C,QAAQ,EAAE,kCAAkC;EAC5C,kBAAkB;EAClB,eAAe;EACf,2BAA2B,EAAE,iCAAiC;AAChE;;AAEA;EACE,sBAAsB,EAAE,kCAAkC;AAC5D;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB","sourcesContent":[".config-cards-container {\n  display: flex;\n  flex-direction: column; /* stack cards vertically */\n  gap: 16px; /* space between cards */\n  max-height: 400px; /* adjust height as needed */\n  overflow-y: auto; /* vertical scroll if content exceeds max-height */\n  padding-right: 4px; /* optional, prevents scrollbar overlapping content */\n  margin-top: 20px;\n}\n\n.reset-link {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: none;\n  background: none;\n  color: #007bff;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.config-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  word-break: break-word; /* prevent text overflow */\n}\n\n.config-card .card-row {\n  display: flex;\n  flex-direction: row; /* keep them in a row */\n  gap: 8px; /* space between label and value */\n  margin-bottom: 8px;\n  font-size: 14px;\n  justify-content: flex-start; /* align everything to the left */\n}\n\n.config-card .card-row span {\n  word-break: break-word; /* prevent overflowing long text */\n}\n\n.config-card .label {\n  font-weight: 500;\n  color: #555;\n  margin-right: 8px;\n}\n\n.config-cards-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.config-cards-container::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
